import styled from "styled-components";

export const HomeStyle = styled.div`
    height: 100vh;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: inherit;
`

export const StaticImage = styled.img`
    position: absolute;
    height: 100%; 
    top: -20px;
    pointer-events: none;
    right: 0;
    z-index: 0;
`

export const SesiImage = styled.img`
    width: 200px;
    height: 90px;
    margin: 0;
`

export const CrewImage = styled.img`
    width: 80px;
    margin-top: auto;
    cursor: pointer;
`

export const WrapContent = styled.div`
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
    /* background-color: red; */

    h1{
        margin: -10px 9px;
        padding: 0;
        color: #FF5742;
    }

    h2{
        color: black;
        font-size: 15px;
        margin-top: 0;
    }
`

export const LoginCard = styled.div`
  position: relative;
  border-radius: 20px;
  background-color: #9AE2E180;
  height: 400px;
  width: 600px;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
  z-index: 999;
`;


export const WrapContentLoginCard = styled.div`
    display: flex;
    flex-direction: column;
    width: 95%;
    height: 85%;
    /* background-color: red; */

    h1{
        color: black;
        font-size: 18px;
        margin-bottom: 10px;
    }

    h2{
        color: black;
        font-size: 18px;
        padding-bottom: 15px;
        font-weight: 400;
    }

    h3{
        color: black;
        font-size: 15px;
        margin: 0;
        padding-left: 5px;
        font-weight: 400;
    }

    a{
        color: #FF5641;
        font-size: 15px;
        font-weight: 700;
        align-self: flex-end;
        margin-right: 5px;
        cursor: pointer;
    }

    h2{
        color: black;
        font-size: 15px;
        margin-left: 10px;
        margin-top: auto;
        margin-bottom: 0;
    }

    p{
        color: #005CA9;
        font-size: 18px;
        font-weight: 400;
        margin-left: 10px;
        margin-top: 0;
        cursor: pointer;
    }
`

export const LoginField = styled.input`
    width: 98%;
    height: 40px;
    background-color: #F2F2F2;
    border: none;
    color: black;
    font-size: 18px;
    font-weight: 500;
    border-end-end-radius: 20px;
    border-end-start-radius: 20px;
    border-start-end-radius: 20px;
    border-start-start-radius: 20px;
    padding-left: 10px;
    margin-bottom: 15px;
    transition: all 0.3s ease;

    &:focus {
        border: 1px solid #5c8e;
        box-shadow: 0 0 8px rgba(92, 142, 200, 0.5); 
        outline: none; 
    }
`

export const EnterButton = styled.button`
  position: absolute;
  bottom: -20px; 
  right: 30px;

  background-color: #FF5641;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  padding: 10px;
  border: none;
  border-radius: 50px / 40px;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
`;


export const SesiImageWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const VersionNumber = styled.span`
  position: absolute;
  top: 0;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 5px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  ${SesiImageWrapper}:hover & {
    opacity: 1;
  }
`;